import React, { Component } from "react";
import "./revokeModalStyles.css"; // Import the CSS file for styles

class RevokeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            revokeRemarks: ""
        };
    }

    handleSubmit = () => {
        const { revokeRemarks } = this.state;
        if (revokeRemarks.trim() !== "") {
            this.props.onSubmit(revokeRemarks);
            this.setState({ revokeRemarks: "" }); // Clear the input after submission
        } else {
            alert("Please enter the revoke remarks.");
        }
    };

    handleInputChange = (e) => {
        this.setState({ revokeRemarks: e.target.value });
    };
    handleCancel = () => {
        this.setState({ revokeRemarks: "" }); // Clear the revokeRemarks state
        this.props.onCancel(); // Call the onCancel prop function passed from parent
    }

    render() {
        const { visible, onCancel } = this.props;
        const { revokeRemarks } = this.state;

        if (!visible) {
            return null; // If modal is not visible, render nothing
        }

        return (
            <div className="modal-overlay">
                <div className="modal-content">
                    <h3 className="f18">Enter Revoke Remarks</h3>
                    <textarea
                        value={revokeRemarks}
                        onChange={this.handleInputChange}
                        rows={3}
                        className="textarea"
                    />
                  
                    <div className="form-group"> 
                                <button type="submit" className="btn btn-success border-radius1 mr-20p" onClick={this.handleSubmit}>Submit</button> 
                                &nbsp;
                                 <button type="button" onClick={this.handleCancel} className="btn btn-default border-radius1" style={{fontWeight:600}}>Cancel</button>
                            </div>
                </div>
            </div>
        );
    }
}

export default RevokeModal;
